/** @jsxImportSource @emotion/react */
import React from "react";
import { Button } from "../../../general/Button/Button";
import { css } from "@emotion/react";

export const ConfirmButton: React.FC<{
  onClick: () => void;
  isVisible?: boolean;
  text: string;
  confirm?: boolean;
}> = ({ onClick, isVisible = true, text, confirm }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <Button
      text={text}
      size="Small"
      buttonType="primary"
      buttonCss={css`
        width: ${confirm ? "135px" : "100px"};
      `}
      height={32}
      onClick={onClick}
    />
  );
};
